import React from "react";
import Lines from "./Lines";
import Progress from "./ProgressDir/Progress";
import "tachyons";
import "./About.css";

const About = () => {
    return (
        <div className="about" id="font">
            <div>
                <h1 className="f2 fw5 black-80 athelas tc ttu">about</h1>
                <center className="lines">
                    <Lines />

                    <p className="f3 fw5 black-80 tc times pv3 ph3 mw7" id="font">
                        Hey, I am Aditya Babar, a Full Stack Developer, a Python enthusiast,
                        and guy slightly obsesed for code Quality. I am currently available
                        for freelance work. If you have a project to get started, want to
                        collaborate or think you need my help with something, then get in
                        touch.
                    </p>
                </center>
                {/* <div className="flex items-center justify-center pa3 mv3">
                    <a
                        href="https://drive.google.com/file/d/1XERIVyGtHzyXkKvCW5Kx0U8ZK4o2lJJ0/view?usp=sharing" target="_blank" rel="noopener noreferrer"
                        className="f5 no-underline black-80 bg-black-80 bg-animate hover-bg-black hover-white inline-flex items-center pa3 ba border-box"
                    >
                        <span className="pl1 ttc white ph3">Download my CV</span>
                    </a>
                </div> */}
            </div>
            <div className="mv5 pv3" id="font">
                <h1 className="f2 fw5 black-80 athelas tc ttu">my skills</h1>
                <center className="lines">
                    <Lines />
                </center>
                <div id="about_progress">
                    <Progress />
                </div>
            </div>
        </div>
    );
};

export default About;
